<template>
<div>
	<Header />
	<div class="class404" :style="{height: vFrameHeight + 'px'}">
		<img class="img404" src="../assets/404.png" alt="" style="margin-top: 40px">
		<p class="info-txt">抱歉，您访问的页面不存在~ </p>
		<!-- <p class="info-time">抱歉，您访问的页面不存在~ </p> -->
		<div class="btn-video-detail" style="margin-top: 50px">
			<div v-if="school_code" class="btn-xuexi" @click="backTo">返回学习中心</div>
		</div>
	</div>
	<Footer />
	</div>
</template>

<script>

import Header from "./Header.vue";
import Footer from "./Footer";
import "../pages/class/class.less";
import utils from "../config/utils";
import { mapState } from "vuex";
export default {
	name: "Class404",
	components: {
		Header,
		Footer
	},
	data() {
		return {
			vFrameHeight: '',
			time: 5,
			inter: null,
			school_code: ''
		};
	},
	destroyed(){
	clearInterval(this.inter)
	},
	mounted() {
		this.school_code = this.appsUserInfo?.school_code || utils.getUrlSchoolCode(window.location.pathname) || ''
		this.vFrameHeight = document.body.clientHeight - 98 - 121;
		// this.inter = setInterval(()=>{
		// 	if(this.time > 1) {
		// 		this.time = this.time - 1
		// 	} else {
		// 		clearInterval(this.inter)
		// 		// utils.redirect(this, "/user/myClass");
		// 	}
			
		// }, 1000)

		this.$store.commit("setNavTitle", {
			navTitle: "",
		});
	},
	methods: {
		backTo(){
			utils.redirect(this, `/${this.school_code}/user/center`);
		}
	},
	computed: {
		...mapState({ appsUserInfo: (state) => state.appsLogin.appsUserInfo }),
	}
};
</script>

<style scoped>
</style>